import React, { Fragment } from "react";

import { Box, Container, Paper, Theme, makeStyles } from "@material-ui/core";

import { CalendarView } from "@ds-developer/calendar";
import { DayView, Legend } from "@hubcapp/components/Calendar/components";
import Scroller from "@hubcapp/components/Calendar/components/Scroller";

import { CalendarProps } from "./types";

const CALENDAR_MAX_WIDTH_DAY = "696px";
const CALENDAR_MAX_WIDTH_WEEK = "1200px";

const useStyles = makeStyles<Theme, { view: CalendarView }>(theme => ({
  root: {
    padding: 0,
    maxWidth: ({ view }) =>
      [CalendarView.day, CalendarView.threeDay].includes(view)
        ? CALENDAR_MAX_WIDTH_DAY
        : CALENDAR_MAX_WIDTH_WEEK,
  },
  calendarWrapper: {
    paddingTop: "114px",
    [theme.breakpoints.up("sm")]: {
      paddingTop: "200px",
    },
    [theme.breakpoints.up("lg")]: {
      paddingTop: "0",
    },
  },
}));

const Calendar: React.FC<CalendarProps> = ({
  events = [],
  view,
  onEventClick = () => {},
  onDateClick = () => {},
  workingHours,
  workingDays = [0, 1, 2, 3, 4, 5, 6],
  scrollTime,
}) => {
  const classes = useStyles({ view });

  return (
    <Fragment>
      <Container classes={{ root: classes.root }}>
        <Scroller />
        {view === CalendarView.month ? (
          <Paper>
            <Box minHeight={300}>TBC</Box>
          </Paper>
        ) : (
          <Box className={classes.calendarWrapper}>
            <DayView
              events={events}
              onEventClick={onEventClick}
              workingHours={workingHours}
              workingDays={workingDays}
              scrollTime={scrollTime}
              onDateClick={onDateClick}
            />
          </Box>
        )}
        <Legend events={events} />
      </Container>
    </Fragment>
  );
};

export default Calendar;
